import { SettingDefinitionModel, SettingModel } from 'models';

import { apiClient } from 'core/api/globals';

// UserRouteService is not needed here anymore as UsersClient handles the route

const SHOWN_RELEASE_NOTES_SETTING_NAME = 'ShownReleaseNotes';

export type ShownReleaseNotesData = Record<string, boolean>;

const getShownData = (userSettings: SettingModel[] | null): ShownReleaseNotesData => {
  if (!userSettings) {
    return {};
  }
  const setting = userSettings.find((s) => s.name === SHOWN_RELEASE_NOTES_SETTING_NAME);

  if (setting?.value) {
    try {
      return JSON.parse(setting.value) as ShownReleaseNotesData;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      console.error(`Error parsing ${SHOWN_RELEASE_NOTES_SETTING_NAME} from user settings:`, errorMessage);
      return {};
    }
  }
  return {};
};

export const hasShownReleaseNote = (templateId: number, userSettings: SettingModel[] | null): boolean => {
  if (!userSettings) return true;
  const data = getShownData(userSettings);
  return !!data[templateId.toString()];
};

export const markReleaseNoteAsShown = async (templateId: number, userSettings: SettingModel[] | null): Promise<void> => {
  const currentData = getShownData(userSettings);
  const newData: ShownReleaseNotesData = {
    ...currentData,
    [templateId.toString()]: true,
  };

  const newSettingValue = JSON.stringify(newData);

  const existingSettingModel = userSettings?.find((s) => s.name === SHOWN_RELEASE_NOTES_SETTING_NAME);

  const settingToUpdate: SettingDefinitionModel = {
    id: existingSettingModel?.id ?? 0,
    name: SHOWN_RELEASE_NOTES_SETTING_NAME,
    value: newSettingValue,
    active: true,
    description: existingSettingModel?.description ?? 'Tracks shown release notes for users',
    system: false,
  };

  try {
    await apiClient.users.updateSettings([settingToUpdate]);
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error(`Error updating ${SHOWN_RELEASE_NOTES_SETTING_NAME} via API:`, errorMessage);
    throw error;
  }
};
